import { SACBaseService } from "./SACBaseService";
export class SACFrontendService extends SACBaseService {
    handleSACAPICall;
    constructor(url, handleSACAPICall) {
        super(url, fetch, (data) => localStorage.setItem("teacherAuth", JSON.stringify(data)), () => {
            try {
                const data = localStorage.getItem("teacherAuth");
                return JSON.parse(data);
            }
            catch (error) {
                console.error(error);
            }
        });
        this.handleSACAPICall = handleSACAPICall;
    }
    async request(_, options) {
        const response = await this.handleSACAPICall(options);
        return response.result || response.data || response;
    }
}
